import { useCallback } from 'react';
import { message } from '@/components';
import { useIntl } from 'umi';
import { useLocalStore } from 'mobx-react';
import { meeting as meetingModel } from '@/models';
import { find } from 'lodash-es';

export interface CoHostChangeResp {
  revokedJointHosts: Array<{ jointHostUid: string; jointHostDeviceId: string }>; //本次撤销联席主持人的设备，需要 toast 提示
  grantedJointHosts: Array<{ jointHostUid: string; jointHostDeviceId: string }>; //本次授权联席主持人的设备，需要 toast 提示
  allJointHosts: Array<{ jointHostUid: string; jointHostDeviceId: string }>; // 所有联席主持人列表
}

export default function useCoHostChange() {
  const meeting = useLocalStore(() => meetingModel);
  const { formatMessage } = useIntl();

  const coHostChange = useCallback(
    (body: CoHostChangeResp) => {
      const { revokedJointHosts, grantedJointHosts } = body;
      if (grantedJointHosts?.length) {
        grantedJointHosts.map((item) => {
          const coHost = find([...meeting.membersMap.values()], { uid: item.jointHostUid });
          if (coHost) {
            message.info({
              content: formatMessage({ id: 'becomeCoHost' }, { name: coHost?.memberName }),
              noIcon: true,
            });
          }
        });
      }
      if (revokedJointHosts?.length) {
        revokedJointHosts.map((item) => {
          const coHost = find([...meeting.membersMap.values()], { uid: item.jointHostUid });
          if (coHost) {
            message.info({
              content: formatMessage({ id: 'revokeHostPrivileges' }, { name: coHost?.memberName }),
              noIcon: true,
            });
          }
        });
      }
      meeting?.updateMemberJoinHostStatus(grantedJointHosts, revokedJointHosts);
    },
    [meeting]
  );

  return coHostChange;
}
